import { useEffect, useRef, useCallback } from 'react';

const ACTIVITY_EVENTS = ['mousemove', 'keydown', 'scroll', 'pointerdown', 'click', 'touchstart'];

export const useUserActivity = (onInactive: () => void, inactivityDelay: number) => {
  const inactivityTimerRef = useRef<number | null>(null);
  const isInactiveRef = useRef(false);

  const handleUserActivity = useCallback(() => {
    if (isInactiveRef.current) {
      isInactiveRef.current = false;
    }

    if (inactivityTimerRef.current) {
      clearTimeout(inactivityTimerRef.current);
    }

    inactivityTimerRef.current = window.setTimeout(() => {
      isInactiveRef.current = true;
      onInactive();
    }, inactivityDelay);
  }, [onInactive, inactivityDelay]);

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      return;
    }

    ACTIVITY_EVENTS.forEach((event) => {
      window.addEventListener(event, handleUserActivity, { passive: true });
    });

    handleUserActivity();

    return () => {
      ACTIVITY_EVENTS.forEach((event) => {
        window.removeEventListener(event, handleUserActivity);
      });

      if (inactivityTimerRef.current) {
        clearTimeout(inactivityTimerRef.current);
      }
    };
  }, [handleUserActivity]);

  return {
    isInactive: isInactiveRef.current,
    resetActivity: handleUserActivity,
  };
};
